var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[ _vm.classes ? _vm.classes : 'btn btn-secondary']},[_vm._v(" "+_vm._s(_vm.texto)+" "),_c('span',{domProps:{"innerHTML":_vm._s('&nbsp')}}),_vm._v(" "),_c('i',{class:[ _vm.icone ? _vm.icone : 'fa fa-check']})])}
var staticRenderFns = []

export { render, staticRenderFns }